
import React from 'react';
import { SignupFormConfig } from '@/schemas/signupFormSchema';
import { FormControl, FormDescription, FormField, FormItem, FormLabel } from '@/components/ui/form';
import { Switch } from '@/components/ui/switch';
import { useForm } from 'react-hook-form';

interface TimestampSettingProps {
  formConfig: SignupFormConfig;
  setFormConfig: React.Dispatch<React.SetStateAction<SignupFormConfig>>;
}

const TimestampSetting: React.FC<TimestampSettingProps> = ({ 
  formConfig,
  setFormConfig
}) => {
  const handleIncludeTimestampChange = (checked: boolean) => {
    setFormConfig(prev => ({
      ...prev,
      includeTimestamp: checked
    }));
  };
  
  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between space-x-2">
        <div>
          <h4 className="font-medium">Include Timestamp</h4>
          <p className="text-sm text-gray-500">
            Add a timestamp to each form submission
          </p>
        </div>
        <Switch 
          checked={formConfig.includeTimestamp}
          onCheckedChange={handleIncludeTimestampChange}
        />
      </div>
    </div>
  );
};

export default TimestampSetting;
